<!-- 圈层触达 -->
<template>
    <div class="wrap">
        <div class="top">
            <h5>圈层触达</h5>
            <div class="right">
                <el-radio-group class="custom-tab" v-model="tab1Position" @change="tab1Change">
                    <el-radio-button label="观看用户">观看用户</el-radio-button>
                    <el-radio-button label="关注用户">关注用户</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="chartContainer">
            <div class="chart">
                <div class="chartTitle"><span>性别分布</span></div>
                <RingChart v-if="sexDistributionData.data.length" :ringChartInfo="sexDistributionData" ref="sexChart"></RingChart>
                <ul class="chartDes">
                    <li v-for="(item, index) in sexDistributionData.data" :key="item.name">
                        <i :style="[{ background: sexDistributionData.color[index] }]"></i>{{ item.name }}({{ item.value
                        }}%)
                    </li>
                </ul>
            </div>
            <div class="chart">
                <div class="chartTitle"><span>年龄分布</span></div>
                <RingChart v-if="ageDistributionData.data.length" :ringChartInfo="ageDistributionData" ref="ageChart"></RingChart>
                <ul class="chartDes">
                    <li v-for="(item, index) in ageDistributionData.data" :key="item.name">
                        <i :style="[{ background: ageDistributionData.color[index] }]"></i>{{ item.name }}({{ item.value
                        }}%)
                    </li>
                </ul>
            </div>
            <div class="chart">
                <div class="chartTitle"><span>粉丝观看占比</span></div>
                <RingChart v-if="fansDistributionData.data.length" :ringChartInfo="fansDistributionData" ref="fansChart"></RingChart>
                <ul class="chartDes">
                    <li v-for="(item, index) in fansDistributionData.data" :key="item.name">
                        <i :style="[{ background: fansDistributionData.color[index] }]"></i>{{ item.name }}({{
                    item.value
                }}%)
                    </li>
                </ul>
            </div>
            <div class="chart">
                <div class="chartTitle"><span>设备分布</span></div>
                <RingChart v-if="equipmenDistributionData.data.length" :ringChartInfo="equipmenDistributionData" ref="equipmenChart"></RingChart>
                <ul class="chartDes">
                    <li v-for="(item, index) in equipmenDistributionData.data" :key="item.name">
                        <i :style="[{ background: equipmenDistributionData.color[index] }]"></i>{{ item.name }}({{
                    item.value }}%)
                    </li>
                </ul>
            </div>
        </div>
        <div class="chartContainer">
            <div class="chart map" >
                <div class="chartTitle"><span>地区分布</span></div>
                <ChinaChart1 v-if="areaPercentageData.data.length" :chinaChartInfo="areaPercentageData" ref="areaChart" />
                <div class="prosses">
                    <el-progress v-for="item in top5Area" :key="item.name" :percentage="item.value"></el-progress>
                    <div class="text">
                        <span v-for="item in top5Area" :key="item.name">{{ item.name }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="other">
            <div class="left">
                <div class="title">近期关注分区</div>
                <div class="list">
                    <ul>
                        <p>一级分区</p>
                        <li v-for="item in firstCategoriesList" :key="item">{{item}}</li>
                    </ul>
                    <ul>
                        <p>二级分区</p>
                        <li v-for="item in secondCategoriesList" :key="item">{{item}}</li>
                    </ul>
                </div>
            </div>
            <div class="right">
                <div class="title">近期关注标签</div>
                <WordCloud v-if="tagsChartInfo.data.length" :info="tagsChartInfo"></WordCloud>
            </div>
        </div>
    </div>
</template>
<script>
import RingChart from "../../../components/Echart/RingChart.vue"
import tools from "../../../components/tools/tools.js";
import ChinaChart1 from "@/components/Echart/ChinaChart1.vue";
const colorList = [
    '#f8793e',
    '#f69764',
    '#fab082',
    '#fcc8a4',
    '#fddfc6',
    '#fcf1e7'
]
export default {
    components: {
        RingChart,
        ChinaChart1,
        WordCloud: () => import("@/components/newEchart/WordCloud.vue"),
    },
    props: ["fatherDarenInfo"],
    data() {
        return {
            flag: true,
            tab1Position: "观看用户",
            //性别分布
            sexDistributionData: {
                nodeId: 'sexChart',//节点
                data: [],//数据
                color: ["#ff5c00", "#40a0fc"],
                guideline: false,
                unit: '%'
            },
            //设备分布
            equipmenDistributionData: {
                nodeId: "equipmenChart", //节点
                data: [], //数据, //数据
                color: colorList,
                unit: "%",
                guideline: false, //引导线
            },
            //年龄分布
            ageDistributionData: {
                nodeId: "ageChart", //节点
                data: [], //数据
                color: colorList,
                unit: "%",
                guideline: false, //引导线
            },
            //粉丝分布
            fansDistributionData: {
                nodeId: "fansChart", //节点
                data: [], //数据
                color: colorList,
                unit: "%",
                guideline: false, //引导线
            },
            // 地域分布
            areaPercentageData: {
                nodeId: 'areaChart',//节点
                data: [],//数据
                text: ["高(%)", "低(%)"]
            },
            top5Area: [],

            firstCategoriesList:[], //一级分区
            secondCategoriesList:[],//二级分区
            // 标签词云
            tagsChartInfo: {
                data: [],
                custom: {
                    series: [{ sizeRange: [10, 50] }]
                }
            }
        }
    },
    methods: {
        tab1Change(tab) {
            this.tab1Position = tab
            this.sexDistributionData.data = []
            this.ageDistributionData.data = []
            this.fansDistributionData.data = []
            this.equipmenDistributionData.data = []
            this.areaPercentageData.data = []
            this.top5Area.data = []
            this.initDarenInfo(this.tab1Position)
        },
        initDarenInfo(type) {
            const val = this.fatherDarenInfo
            let obj = {}
            // 圈层触达
            let sexDistributionData = {
                ...this.sexDistributionData,
                data: [
                    { value: val[type == '观看用户'?'sax_distributions_audience':'sax_distributions'][1].count, name: '女性' },
                    { value: val[type == '观看用户'?'sax_distributions_audience':'sax_distributions'][0].count, name: '男性' }
                ],
            }
            let ageDistributionData = {
                ...this.ageDistributionData,
                data: val[type == '观看用户'?'age_distributions_audience':'age_distributions'].map(item => {
                    return {
                        value: item.count,
                        name: item.section_desc
                    }
                })
            }
            let fansDistributionData = {
                ...this.fansDistributionData,
                data: val.fans_vv_distributions_audience.map(item => {
                    return {
                        value: item.count,
                        name: item.section_desc
                    }
                })
            }
            let equipmenDistributionData = {
                ...this.equipmenDistributionData,
                data: val[type == '观看用户'?'device_distributions_audience':'device_distributions'].map(item => {
                    return {
                        value: item.count,
                        name: item.section_desc
                    }
                })
            }

            let areaPercentageData = {
                ...this.areaPercentageData,
                data: val[type == '观看用户'?'top_region_distributions_audience':'top_region_distributions'].map(item => {
                    return {
                        value: item.count,
                        name: item.section_desc
                    }
                })
            }

            this.firstCategoriesList = val[type == '观看用户'?'first_categories_profile_audience':'first_categories_profile'] //一级分区
            this.secondCategoriesList = val[type == '观看用户'?'second_categories_profile_audience':'second_categories_profile']  //二级分区

            // 词云组件内部有进行监听数据源，可以直接生效
            this.tagsChartInfo = {
                ...this.tagsChartInfo,
                data:val[type == '观看用户'?'tag_profile_audience':'tag_profile'].map(item => {
                    return {
                        value: item.count,
                        name: item.section_desc
                    }
                })
            }
            this.$nextTick(()=>{
                this.darenInfo = obj
                this.sexDistributionData = sexDistributionData
                this.ageDistributionData = ageDistributionData
                this.fansDistributionData = fansDistributionData
                this.equipmenDistributionData = equipmenDistributionData
                this.areaPercentageData = areaPercentageData
                // 从大到小，取前五
                this.top5Area = areaPercentageData.data.toSorted((a,b)=>b.value - a.value).slice(0,5)
            })
        },
    },
    created() {
        this.initDarenInfo(this.tab1Position)
    }
};
</script>
<style lang='scss' scoped>
.chartContainer {
    width: 100%;
    padding: 10px 0;
    // overflow: hidden;
    display: flex;

}

.chartContainer .chart {
    // float: left;
    position: relative;
    flex: 1 1 261px;
    min-height: 300px;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    &.map{
        display: flex;
    }
}

.chartContainer .chart .chartDes {
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    bottom: 10px;
    padding: 0;
    font-size: 12px;
    color: #8d9099;
}

.chartContainer .chart .chartDes li {
    float: left;
    width: 124px;
    margin-top: 6px;
}

.chartContainer .chart .chartDes li:nth-of-type(2n) {
    margin-right: 0;
}

.chartContainer .chart .chartDes li i {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 6px;
    border-radius: 6px;
}

#sexChart,
#ageChart,
#equipmenChart,
#fansChart {
    flex: 1;
    height: 180px;
}

#areaChart {
    float: left;
    width: 460px;
    height: 360px;
}

.chartContainer .chart .prosses {
    position: relative;
    // float: left;
    margin-left: 40px;
    width: 280px;
    height: 200px;
    margin-top: 100px;

}

::v-deep .el-progress-bar {
    width: 90%;
}

.chartContainer .chart .prosses .el-progress {
    margin-bottom: 26px;
}

.chartContainer .chart .prosses .text {
    position: absolute;
    top: 0;
    left: -60px;
}

.chartContainer .chart .prosses .text span {
    display: block;
    width: 80px;
    margin-bottom: 23px;
    color: #8d9099;
    font-size: 14px;
}

.other {

    display: flex;

    .left {
        width: 30%;

        .list {
            display: flex;
            text-align: center;

            p {
                color: rgb(134, 144, 156);
            }

            ul {
                /* 初始化计数器 */
                counter-reset: list-item-counter;
                width: 170px;
                padding: 0;
                text-align: left;
                font-size: 14px;

                li {
                    line-height: 2em;

                    &::before {
                        counter-increment: list-item-counter;
                        content: counter(list-item-counter);
                        color: #86909c;
                        font-size: 1em;
                        line-height: 1em;
                        display: inline-block;
                        margin-right: 16px;
                    }

                    &:nth-of-type(-n+3)::before {
                        color: #ff6f28;
                    }
                }
            }


        }
    }

    .right {
        width: 70%;
    }
}
</style>